import { render, staticRenderFns } from "./OpeningBalance.vue?vue&type=template&id=8d613314&"
import script from "./OpeningBalance.vue?vue&type=script&lang=js&"
export * from "./OpeningBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports